export default __webpack_public_path__ + "static/media/jackpot.da1ef2b3.png";